import { useMemo } from "react"
import { useOpco } from "."
import { Opco } from "../models"

export function useBrandName(): string {
  const opco: Opco = useOpco()

  const brandName: string = useMemo<string>(() => {
    switch (opco) {
      case Opco.Noordhoff:
        return "Bosatlas"
      case Opco.Plantyn:
        return "Wereldatlas"
      case Opco.Liber:
        return "Varldsatlas"
    }
  }, [opco])

  return brandName
}
